import { render, staticRenderFns } from "./EditDatabaseModal.vue?vue&type=template&id=1b135176&scoped=true&lang=pug&"
import script from "./EditDatabaseModal.vue?vue&type=script&lang=ts&"
export * from "./EditDatabaseModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditDatabaseModal.vue?vue&type=style&index=0&id=1b135176&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b135176",
  null
  
)

export default component.exports